import * as React from 'react'

import { Checkbox } from '@/components/ui/checkbox'
import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from './Command'
import { cn } from '@/lib/utils'

const sortOptions = (
  options: {
    value: string
    label: string
  }[],
  values: Set<string>
) => {
  options.sort((a, b) => {
    if (values.has(a.value) && !values.has(b.value)) return -1
    if (!values.has(a.value) && values.has(b.value)) return 1
    return a.label.localeCompare(b.label)
  })
}

export function SelectSearchFilter({
  className,
  multiple = false,
  notFoundText = 'No se encontraron resultados',
  onSelect,
  options = [],
  placeholder = 'Buscar',
  preValues = new Set([] as string[]),
}: {
  className: string
  multiple?: boolean
  options?: { value: string; label: string }[]
  onSelect?: (values: string[], value: string) => void
  preValues?: Set<string>
  placeholder?: string
  notFoundText?: string
}) {
  const [values, setValues] = React.useState(preValues)
  return (
    <Command
      className={className}
      onBlur={() => (options.length > 8 ? sortOptions(options, values) : null)}
    >
      {options.length > 5 && <CommandInput className="h-9" placeholder={placeholder} />}
      <CommandEmpty>{notFoundText}</CommandEmpty>
      <CommandList>
        <CommandGroup className="max-h-72 overflow-y-auto">
          {options?.map((option) => (
            <CommandItem
              className="gap-2 text-[14px] font-light"
              key={option.value}
              onSelect={(selectedValue: string) => {
                if (!multiple) {
                  if (values.has(selectedValue)) {
                    values.delete(selectedValue)
                  } else {
                    values.clear()
                    values.add(selectedValue)
                  }
                } else {
                  if (values.has(selectedValue)) {
                    values.delete(selectedValue)
                  } else {
                    values.add(selectedValue)
                  }
                  setValues(new Set(values))
                }
                onSelect?.([...values], selectedValue)
              }}
              value={option.value}
            >
              <Checkbox checked={values.has(option.value)} className={cn('h-4 w-4')} />
              {option.label}
            </CommandItem>
          ))}
        </CommandGroup>
      </CommandList>
    </Command>
  )
}
